import axiosInstance from "./instance";

// Get All Vendors by Status
const fetchRiders = async (page, status) => {

    console.log('Start Fetching RIders');
    console.log(`Page - ${page}`);
    console.log(`Status - ${status}`);

    const response = await axiosInstance.get('/riders', {
        params: {
            page,
            status
        }
    });

    console.log('12 - After fetching Riders');
    console.log(response.data);
    return response.data;
}

// Get Solo Order Details
const fetchRider = async (riderId) => {
    const response = await axiosInstance.get(`/riders/solo`, {
        params: {
            riderId
        }
    });
    return response.data;
}

// Get Rider Earning 
const getEarning = async (riderId, startDate, endDate) => {

    // const normalizedEndDate = new Date(endDate);
    // normalizedEndDate.setHours(23, 59, 59, 999);


    const response = await axiosInstance.get(`/rider/earning`, {
        params: {
            riderId,
            startDate,
            endDate
        }
    });
    return response.data;
}

const updateRider = async (riderId, status) => {

    console.log(riderId);
    console.log(status);

    const response = await axiosInstance.put('/riders', {
        riderId,
        status
    });

    console.log(response.data);

    return response.data;

}

const fetchDashboardRiders = async () => {
    const response = await axiosInstance.get('/dashboard/riders');
    return response.data;
}

export { fetchRiders, fetchRider, updateRider, fetchDashboardRiders, getEarning };